export default {
  label: 'Zeilenende',
  placeholder: 'Wählen Sie einen Zeilenumbruch',
};
